(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["certificate-verify"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ROOT_SELECTOR = '[data-certificate-verify]';

    function readMessages(root) {
      var script = root.querySelector('[data-certificate-messages]');
      if (!script) return {};
      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        return {};
      }
    }

    function showDialog(root, node) {
      var dialog = root.querySelector('[data-certificate-dialog]');
      var content = root.querySelector('[data-certificate-dialog-content]');
      content.replaceChildren(node);
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    }

    function textNode(title, text) {
      var wrapper = document.createElement('div');
      if (title) {
        var heading = document.createElement('h3');
        heading.textContent = title;
        wrapper.appendChild(heading);
      }
      if (text) {
        var paragraph = document.createElement('p');
        paragraph.textContent = text;
        wrapper.appendChild(paragraph);
      }
      return wrapper;
    }

    function buildResultNode(messages, resultEl) {
      var status = resultEl.dataset.certificateStatus;
      var edition = resultEl.dataset.certificateEdition || '';
      var work = resultEl.querySelector('[data-certificate-work]');

      var titleKey = status + '_title';
      var textKey = status + '_text';
      var node = textNode(messages[titleKey], messages[textKey]);

      if (status === 'valid') {
        if (edition && messages.edition_format) {
          var editionParagraph = document.createElement('p');
          editionParagraph.className = 'certificate-result__edition';
          editionParagraph.textContent = messages.edition_format.replace('[edition]', edition);
          node.appendChild(editionParagraph);
        }
        if (work) node.appendChild(work);
      }

      return node;
    }

    async function verify(root, code) {
      var messages = readMessages(root);
      var button = root.querySelector('[data-certificate-submit]');
      var value = (code || '').trim();

      if (!value) {
        showDialog(root, textNode(null, messages.error_empty));
        return;
      }

      if (button) button.disabled = true;

      try {
        var url =
          root.dataset.searchUrl +
          '?q=' + encodeURIComponent(value) +
          '&section_id=' + encodeURIComponent(root.dataset.resultSection) +
          '&_=' + Date.now();

        var response = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Request failed: ' + response.status);

        var html = await response.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var result = doc.querySelector('[data-certificate-status]');
        if (!result) throw new Error('Result block not found');

        showDialog(root, buildResultNode(messages, result));
      } catch (error) {
        showDialog(root, textNode(null, messages.error_network));
      } finally {
        if (button) button.disabled = false;
      }
    }

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-certificate-form]');
      if (!form) return;
      event.preventDefault();
      var root = form.closest(ROOT_SELECTOR);
      verify(root, form.elements.code ? form.elements.code.value : '');
    });

    document.addEventListener('click', function (event) {
      var dialog = event.target.closest('[data-certificate-dialog]');
      var isClose = event.target.closest('[data-certificate-close]');
      if (isClose) {
        event.target.closest('[data-certificate-dialog]').close();
      } else if (dialog && event.target === dialog) {
        dialog.close();
      }
    });

    document.addEventListener('DOMContentLoaded', function () {
      var root = document.querySelector(ROOT_SELECTOR);
      if (!root) return;
      var preset = new URLSearchParams(window.location.search).get('code');
      if (!preset) return;
      var form = root.querySelector('[data-certificate-form]');
      if (!form || !form.elements.code) return;
      form.elements.code.value = preset;
      verify(root, preset);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
